import { useNavigate, useParams } from "react-router-dom";

type CustomTileProps = {
  label: string;
  navigateTo: string;
};

export const CustomTile = ({ label, navigateTo }: CustomTileProps) => {
  const navigate = useNavigate();
  const { site } = useParams();

  return (
    <div
      className="p-1 box-border h-full cursor-pointer hover:opacity-80 transition-opacity duration-200"
      onClick={() => navigate(`/${site}${navigateTo}`)}
    >
      <div className="border-4 border-dashed overflow-hidden rounded-md border-slate-300 dark:border-slate-700 h-full flex items-center justify-center bg-slate-50 dark:bg-slate-900">
        <div className="text-center p-4">
          <div className="text-4xl mb-2">+</div>
          <div className="text-sm font-medium">{label}</div>
        </div>
      </div>
    </div>
  );
};

export const createCustomTileItem = (
  label: string,
  navigateTo: string,
  height: number = 512
) => ({
  width: 512,
  height,
  id: "custom",
  render: <CustomTile label={label} navigateTo={navigateTo} />,
});
